// Floating scroll-to-top button. Appears when user scrolls past ~400px.
import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

export default function ScrollToTop() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  if (!visible) return null;
  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="fixed bottom-24 left-4 sm:left-6 z-30 w-11 h-11 rounded-full bg-card-1 border border-line-strong text-app shadow-2xl backdrop-blur-xl flex items-center justify-center hover:bg-card-2 transition-colors"
      aria-label="Remonter en haut"
      data-testid="scroll-to-top-btn"
      style={{ backgroundColor: "color-mix(in oklab, var(--card) 90%, transparent)" }}
    >
      <ArrowUp size={18} />
    </button>
  );
}
